import React, { useState } from 'react';
import { NAV_LINKS } from '../../constants';
import Logo from '../../images/svg/logo.svg';
import MenuIcon from '../menu-icon';
import './navbar.scss';

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="navbar container">
      <a className="navbar__logo" href="/">
        <Logo />
      </a>

      <ul className="navbar__links-list">
        {NAV_LINKS.map((link) => (
          <li className="navbar__links-item" key={link.text}>
            <a
              className="navbar__link"
              href={link.to}
              target="_blank"
              rel="noopener noreferrer"
            >
              {link.text}
            </a>
          </li>
        ))}
      </ul>

      <button
        className="navbar__menu-toggle"
        type="button"
        aria-label="Show links"
        onClick={() => setIsMenuOpen((state) => !state)}
      >
        <MenuIcon open={isMenuOpen} />
      </button>

      {isMenuOpen && (
        <ul className="navbar__menu">
          {NAV_LINKS.map((link) => (
            <li key={link.text}>
              <a
                className="navbar__menu-link"
                href={link.to}
                target="_blank"
                rel="noopener noreferrer"
              >
                {link.text}
              </a>
            </li>
          ))}
        </ul>
      )}
    </header>
  );
}

export default Navbar;
